import { Typography } from "@mui/material";
import { EllipsesStyle } from "../Types/IEllipsesStyle";
import { IKeyDriveFonts } from "../Types/IKeyDriveFonts";

export function KeyDriveCaption({
    needEllipses,
    text,
    color,
    needBold,
    fontStyle
}: IKeyDriveFonts) {

    function fontStyleHandler(input: string | undefined) {
        switch(input) {
            case "italic":
                return "italic"
            default:
                return undefined
        }
    }

    return (
        <Typography
            variant="caption"
            fontFamily="SEGOE UI"
            fontSize="12px"
            lineHeight="18px"
            color={color}
            fontStyle={fontStyleHandler(fontStyle)}
            fontWeight={needBold ? 600 : 400}
            sx={needEllipses ? EllipsesStyle : {}}
            textTransform="none"
        >
            { text }
        </Typography>
    )
}